import React, { memo, useMemo } from 'react'
import Chip from '@material-ui/core/Chip'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'

import styles from './styles'
import { useTagsState } from '../reducer'
import { ETagActionType, ITag } from 'models'
import Loading from 'components/loading'

const useStyles = makeStyles(styles)

const AvailableTags: React.FunctionComponent<{
	pristine?: boolean
	loading: boolean
}> = ({ pristine, loading }) => {
	const classes = useStyles()
	const { t } = useTranslation()
	const [{ available: availableTags, selected }, dispatch] = useTagsState()
	const selectedTags = useMemo(() => selected.map((item: ITag) => item.id), [
		selected,
	])
	const select: any = (tag: ITag) => () => {
		dispatch({
			type: ETagActionType.select,
			tag,
		})
	}
	const deselect: any = (tag: ITag) => () => {
		dispatch({
			type: ETagActionType.deselect,
			tag,
		})
	}

	return (
		<>
			{!loading &&
				availableTags.map((item: ITag) => (
					<Chip
						key={item.id}
						variant="outlined"
						className={
							selectedTags.length === 5 &&
							selectedTags.indexOf(item.id) === -1
								? classes.chipInactive
								: selectedTags.indexOf(item.id) !== -1
								? classes.chipActive
								: classes.chip
						}
						label={item.title}
						clickable={
							selectedTags.length !== 5 ||
							selectedTags.indexOf(item.id) !== -1
						}
						onDelete={
							selectedTags.indexOf(item.id) !== -1
								? deselect(item)
								: null
						}
						onClick={
							selectedTags.length === 5 &&
							selectedTags.indexOf(item.id) === -1
								? null
								: selectedTags.indexOf(item.id) !== -1
								? deselect(item)
								: select(item)
						}
					/>
				))}
			{loading && <Loading size={48} style={{ margin: '20px auto' }} />}
			{!loading && pristine && availableTags.length === 0 && (
				<div className={classes.notFound}>{t('No tags found')}</div>
			)}
		</>
	)
}

export default memo(AvailableTags)
